module.exports = __webpack_public_path__ + "static/media/gw.5ca4e2b7.png";